import { create } from 'zustand';

interface TabAlertState {
  /** Количество новых permission_request, пришедших пока вкладка была скрыта */
  alertCount: number;
  /** Базовый title от текущего экрана (без префикса счётчика) */
  baseTitle: string;
  /** Увеличить счётчик на 1 */
  increment: () => void;
  /** Сбросить счётчик в 0 */
  reset: () => void;
  /** Установить базовый title (вызывается из useDocumentTitle) */
  setBaseTitle: (title: string) => void;
}

export const useTabAlertStore = create<TabAlertState>((set) => ({
  alertCount: 0,
  baseTitle: 'Claude Remote',
  increment: () => set((s) => ({ alertCount: s.alertCount + 1 })),
  reset: () => set({ alertCount: 0 }),
  setBaseTitle: (title) => set({ baseTitle: title }),
}));
